import React from "react";
import { ASSET_PATHS } from "./assets";
import { all_links } from "./links";

export const ActionPromoSection = () => {
  const [activeTab, setActiveTab] = React.useState("sonic");
const pricing_logs = [
  {
    icon: ASSET_PATHS.pricing_logos.popular,
    name: "Popular Captcha",
    url: all_links.pricing_api_links.popular
  },
  {
    icon: ASSET_PATHS.pricing_logos.bls,
    name: "BLS Captcha",
    url: all_links.pricing_api_links.bls
  },
  {
    icon: ASSET_PATHS.pricing_logos.recaptcha,
    name: "reCAPTCHA V2",
    url: all_links.pricing_api_links.recaptcha
  },
  {
    icon: ASSET_PATHS.pricing_logos.aws,
    name: "AWS WAF",
    url: all_links.pricing_api_links.aws
  },
  {
    icon: ASSET_PATHS.pricing_logos.geetest,
    name: "Geetest New",
    url: all_links.pricing_api_links.geetest4_new
  },
  {
    icon: ASSET_PATHS.pricing_logos.imagetotext,
    name: "ImageToText",
    url: all_links.pricing_api_links.imagetotext
  },
  {
    icon: ASSET_PATHS.pricing_logos.mtcaptcha,
    name: "MtCaptcha",
    url: all_links.pricing_api_links.mtcaptcha
  },
  {
    icon: ASSET_PATHS.pricing_logos.prosopo,
    name: "Prosopo",
    url: all_links.pricing_api_links.prosopo
  },
  {
    icon: ASSET_PATHS.pricing_logos.tiktok,
    name: "TikTok Captcha",
    url: all_links.pricing_api_links.tiktok
  },
  {
    icon: ASSET_PATHS.pricing_logos.captchafox,
    name: "CaptchaFox",
    url: all_links.pricing_api_links.captchafox
  },
  {
    icon: ASSET_PATHS.pricing_logos.cloudflare,
    name: "Cloudflare Challenge",
    url: all_links.pricing_api_links.cloudflareChallenge
  }
];


return (
  <section
    id="extension"
    className="bg-gradient-to-br mt-10 from-[#130236] to-[#000000] text-[#cbc0e7] py-12 md:py-20"
  >
    <div className="container mx-auto px-4">
      {/* Unified Card with Everything Inside */}
      <div className="w-full bg-gradient-to-bl from-[#000206]/70 to-[#006daa]/70 border border-white/30 rounded-3xl p-8 md:p-12 backdrop-blur-md shadow-2xl">
        <div className="flex flex-col lg:flex-row items-start gap-10">
          {/* Left Side: Text + Tabs + Buttons */}
          <div className="w-full lg:w-1/2 text-left">
                <h2 className="font-pixel text-4xl sm:text-5xl md:text-6xl mb-6 bg-gradient-to-r from-white via-cyan-200 to-blue-300 bg-clip-text text-transparent animate-pulse">
                  Say goodbye to Frustrating CAPTCHAs
                </h2>
                <p className="font-kodeMono text-base sm:text-lg md:text-xl mb-6 max-w-2xl text-gray-300/90 leading-relaxed">
                 <span className="font-bold text-xl text-green-600"> With CaptchaSonic browser extension,</span> experience lightning-fast AI-powered CAPTCHA solving—saving you time and effort.
                </p>
                
              <div className="flex flex-col items-center w-full">

          {/* --- NEW: Vertically Aligned Sections with Side-by-Side Layout --- */}
          <div className="w-full flex flex-col items-start gap-12 mt-12">

            {/* --- Section 1: All Captcha's Sonic --- */}
            <div className="w-full flex flex-col md:flex-row items-start gap-8">
              {/* MODIFIED: Vertically stacked title */}
              <h3 className="font-pixel text-3xl text-white uppercase leading-tight flex-shrink-0 mt-10">
                All
              </h3>
              {/* The buttons for this section */}
              <div className="flex flex-wrap justify-start gap-4">
                <a
                  href= {all_links.all.chrome_extension}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative inline-block p-1 rounded-xl bg-gradient-to-r from-emerald-400 via-green-300 to-white shadow-lg shadow-emerald-500/30 transition-all duration-300 ease-in-out hover:-translate-y-1 active:scale-95"
                >
                  <span className="flex items-center justify-center gap-3 px-8 py-4 bg-slate-900 rounded-lg">
                    <img src={ASSET_PATHS.chrome} alt="Chrome" className="h-7 w-7" />
                    <span className="text-lg font-bold text-slate-100 whitespace-nowrap">Add to Chrome</span>
                  </span>
                </a>
                <a
                  href= {all_links.all.firefox_extension}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative inline-block p-1 rounded-xl bg-gradient-to-r from-emerald-400 via-green-300 to-white shadow-lg shadow-emerald-500/30 transition-all duration-300 ease-in-out hover:-translate-y-1 active:scale-95"
                >
                  <span className="flex items-center justify-center gap-3 px-8 py-4 bg-slate-900 rounded-lg">
                    <img src={ASSET_PATHS.firefox} alt="Firefox" className="h-7 w-7" />
                    <span className="text-lg font-bold text-slate-100 whitespace-nowrap">Add to Firefox</span>
                  </span>
                </a>
                <a
                  href={all_links.all.zip}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative inline-block p-1 rounded-xl bg-gradient-to-r from-emerald-400 via-green-300 to-white shadow-lg shadow-emerald-500/30 transition-all duration-300 ease-in-out hover:-translate-y-1 active:scale-95"
                >
                  <span className="flex items-center justify-center gap-3 px-8 py-4 bg-slate-900 rounded-lg">
                    <img src={ASSET_PATHS.zip} alt="Zip" className="h-7 w-7" />
                    <span className="text-lg font-bold text-slate-100 whitespace-nowrap">Download Zip</span>
                  </span>
                </a>
              </div>
            </div>

            {/* --- Section 2: BLS OCR Solver --- */}
            <div className="w-full flex flex-col md:flex-row items-start gap-8">
              {/* MODIFIED: Vertically stacked title */}
              <h3 className="font-pixel text-3xl text-white uppercase leading-tight flex-shrink-0 mt-12">
                BLS <br /> OCR
              </h3>
              {/* The buttons for this section */}
              <div className="flex flex-wrap justify-start gap-4">
                <a
                  href={all_links.bls.chrome_store}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative inline-block p-1 rounded-xl bg-gradient-to-r from-emerald-400 via-green-300 to-white shadow-lg shadow-emerald-500/30 transition-all duration-300 ease-in-out hover:-translate-y-1 active:scale-95"
                >
                  <span className="flex items-center justify-center gap-3 px-8 py-4 bg-slate-900 rounded-lg">
                    <img src={ASSET_PATHS.chrome} alt="Chrome" className="h-7 w-7" />
                    <span className="text-lg font-bold text-slate-100 whitespace-nowrap">Add to Chrome</span>
                  </span>
                </a>
                <a
                  href={all_links.bls.firefox_Store}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative inline-block p-1 rounded-xl bg-gradient-to-r from-emerald-400 via-green-300 to-white shadow-lg shadow-emerald-500/30 transition-all duration-300 ease-in-out hover:-translate-y-1 active:scale-95"
                >
                  <span className="flex items-center justify-center gap-3 px-8 py-4 bg-slate-900 rounded-lg">
                    <img src={ASSET_PATHS.firefox} alt="Firefox" className="h-7 w-7" />
                    <span className="text-lg font-bold text-slate-100 whitespace-nowrap">Add to Firefox</span>
                  </span>
                </a>
                <a
                  href={all_links.bls.zip_store}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative inline-block p-1 rounded-xl bg-gradient-to-r from-emerald-400 via-green-300 to-white shadow-lg shadow-emerald-500/30 transition-all duration-300 ease-in-out hover:-translate-y-1 active:scale-95"
                >
                  <span className="flex items-center justify-center gap-3 px-8 py-4 bg-slate-900 rounded-lg">
                    <img src={ASSET_PATHS.zip} alt="Zip" className="h-7 w-7" />
                    <span className="text-lg font-bold text-slate-100 whitespace-nowrap">Download Zip</span>
                  </span>
                </a>
              </div>
            </div>

          </div>
          </div>
          </div>

          {/* Right Side: Image */}
          <div className="w-full lg:w-1/2 flex justify-center mt-20">
            <img
              className="w-full max-w-2xl rounded-2xl shadow-[0_0_60px_rgba(255,255,255,0.15)]"
              src={ASSET_PATHS.extensionImage.extension}
              alt="CaptchaSonic Extension"
            />
          </div>
        </div>

        {/* --- NEW: Thick, Glowing Beam Separator --- */}
        <div className="my-16 lg:my-15">
          <div className="relative w-full h-24">
            {/* <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(234,179,8,0.20)_0%,transparent_70%)]"></div> */}
            <div className="absolute top-1/2 left-0 -translate-y-1/2 w-full h-[2px] bg-gradient-to-r from-transparent via-green-300 to-transparent opacity-80"></div>
          </div>
        </div>
        {/* --- End of Separator --- */}

      {/* Bottom Section: Logos + Scrolling Transition */}
      <div className="mt-16 flex flex-col lg:flex-row gap-8">
        
        {/* Left: Clickable Product Logos (More Compact Grid) */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {pricing_logs.slice(0, 11).map((item, idx) => (
              <a
                key={idx}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative flex flex-col items-center gap-2 p-3 rounded-2xl transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]"
              >
                {/* --- The card's internal styling remains exactly the same --- */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-white/5 to-white/2 backdrop-blur-[16px] shadow-[inset_0_1px_1px_rgba(255,255,255,0.1)] overflow-hidden transition-all duration-700">
                  <div className="absolute inset-0 bg-black/30 rounded-2xl" />
                  <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-20 group-hover:opacity-40 transition-opacity duration-1000" />
                  <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxmZUNvbXBvc2l0ZSBpZD0ibm9pc2UiIG9wZXJhdG9yPSJhdG9wIiBpbj0iU291cmNlR3JhcGhpYyI+PGZlVHVyYnVsZW5jZSB0eXBlPSJmcmFjdGFsTm9pc2UiIGJhc2VGcmVxdWVuY3k9IjAuNSIgbnVtT2N0YXZlcz0iNSIgc3RpdGNoVGlsZXM9InN0aXRjaCIvPjwvZmVDb21wb3NpdGU+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idHJhbnNwYXJlbnQiIHN0eWxlPSJmaWx0ZXI6dXJsKCNub2lzZSk7IG9wYWNpdHk6MC4wMyIvPjwvc3ZnPg==')]" />
                </div>
                <div className="relative z-10 p-2 rounded-xl bg-gradient-to-br from-white/15 to-white/5 backdrop-blur-[4px] border border-white/10 group-hover:border-white/20 transition-all duration-300">
                  <img
                    src={item.icon}
                    alt={item.name}
                    className="h-10 w-10 object-contain brightness-100 contrast-110 group-hover:brightness-110 group-hover:scale-105 transition-all duration-300"
                    style={{
                      filter: "drop-shadow(0 3px 6px rgba(0,0,0,0.3))",
                      WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 70%, rgba(0,0,0,0.8) 100%)"
                    }}
                  />
                </div>
                <span className="relative z-10 text-sm font-kodeMono font-medium tracking-wider text-white/95 group-hover:text-white transition-colors duration-300 px-3 py-1 text-center">
                  {item.name}
                  <span className="absolute bottom-0 left-1/2 w-4/5 h-[1.5px] bg-gradient-to-r from-transparent via-white/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 -translate-x-1/2" />
                </span>
                <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden">
                  <div className="absolute -inset-3 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.2)_0%,transparent_70%)] animate-[pulse_6s_ease-in-out_infinite]" />
                </div>
              </a>
            ))}
          </div>
        </div>
          {/* Right: Scrolling Logos Transition */}
          <div className="w-full lg:w-1/2">
            <div className="font-kodeMono text-2xl sm:text-3xl md:text-4xl pb-4 flex items-center bg-clip-text animate-pulse">
              ARE YOU HUMAN?
              <img
                className="inline w-6 h-6 sm:w-8 sm:h-8 ml-2"
                src={ASSET_PATHS.extensionImage.neutralFace}
                alt="Neutral Face"
              />
            </div>
            <p className="font-kodeMono text-base sm:text-lg text-gray-300 mb-5">
              No more frustrating challenges—just smooth, accurate, and reliable CAPTCHA solving. Let Captcha Sonic handle the rest!
            </p>
            <div className="flex-grow w-full max-w-lg mx-auto overflow-hidden relative h-[15rem] sm:h-[18.5rem]">
              <div className="grid grid-cols-2 gap-4 h-full">
                <div className="space-y-4 animate-scroll-up">
                  {Array.from({ length: 16 }).map((_, idx) => (
                  <img
                    key={`scroll-up-${idx}`}
                    src={ASSET_PATHS.logos(idx % 8 + 1)}
                    alt={`Logo ${idx % 8 + 1}`}
                    className="h-14 sm:h-20 md:h-24 w-auto object-contain mx-auto brightness-110 contrast-125 opacity-80 hover:opacity-100 hover:scale-105 transition-all duration-500"
                    style={{
                      filter: "drop-shadow(0 3px 6px rgba(255,255,255,0.05)) drop-shadow(0 2px 8px rgba(0,0,0,0.3))",
                      WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 80%, rgba(0,0,0,0.6))"
                    }}
                  />
                  ))}
                </div>
                <div className="space-y-4 animate-scroll-down">
                  {Array.from({ length: 16 }).map((_, idx) => (
                   <img
                    key={`scroll-down-${idx}`}
                    src={ASSET_PATHS.logos(idx % 8 + 1)}
                    alt={`Logo ${idx % 8 + 1}`}
                    className="h-14 sm:h-20 md:h-24 w-auto object-contain mx-auto brightness-110 contrast-125 opacity-80 hover:opacity-100 hover:scale-105 transition-all duration-500"
                    style={{
                      filter: "drop-shadow(0 3px 6px rgba(255,255,255,0.05)) drop-shadow(0 2px 8px rgba(0,0,0,0.3))",
                      WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 80%, rgba(0,0,0,0.6))"
                    }}
                  />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <style jsx global>{`
          @keyframes scroll-up {
            0% {
              transform: translateY(0);
            }
            100% {
              transform: translateY(-100%);
            }
          }

          @keyframes scroll-down {
            0% {
              transform: translateY(-100%);
            }
            100% {
              transform: translateY(0);
            }
          }

          .animate-scroll-up {
            animation: scroll-up 20s linear infinite;
          }

          .animate-scroll-down {
            animation: scroll-down 20s linear infinite;
          }

          .animate-scroll-up:hover,
          .animate-scroll-down:hover {
            animation-play-state: paused;
          }
        `}</style>
      </div>
    </div>
  </section>
);
};